module.exports = __webpack_public_path__ + "assets/img/id-card-back.c0e331b7.png";